import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs4"; // or "datatables.net" for custom styling
import { Link } from "react-router-dom";
import FormModal from "../../../Components/FormModal/FormModal";
import ConfirmModal from "../../../Components/ConfirmModal/ConfirmModal";
import ContentHeader from "../../../Components/ContentHeader/ContentHeader";
import Loading from "../../../Components/Loading/Loading";
import Table from "../../../Components/Table/Table";
import { Formik } from "formik";
import Search from "../../../Components/Search/Search";
import CustomToast from "../../../Components/CustomToast/CustomToast";

function RrbPageUi({
  columns,
  data,
  totalRecords,
  deleteFn,
  loading,
  tableQaury,
  onPageChange,
  setTableQaury,
  decodedToken,
  setUpDateData,
  setShowForm,
  showForm,
  updateData,
  handleCloseModal,
  handleChange,
  handleSubmit,
  isRRBError,
  toast
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            {/* <ContentHeader
              title={"RRB"}
              buttonName={"Add RRB"}
              buttonBoolean={true}
              pageName={""}
              linkPath={"/master-data/create-rrb"}
            /> */}
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1>RRB</h1>
                  </div>
                </div>
              </div>
            </section>
            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                      {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <Search
                            setTableQaury={setTableQaury}
                            tableQaury={tableQaury}
                            placeHolder={"Search By Here"}
                            buttonName={"Add RRB"}
                            buttonBoolean={false}
                            linkPath={""}
                          />
                          <div className="d-flex justify-content-end align-items-end" style={{minWidth:"130px"}}>
                              <button
                                data-toggle="modal"
                                data-target="#modal-default"
                                className="blue-btn"
                                onClick={() => {
                                  setUpDateData("");
                                  setShowForm(true);
                                }}
                              >
                                Add RRB
                              </button>
                          
                          </div>
                        </div>
                        <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
      {showForm && (
        <Formik
          initialValues={{
            rrbs: updateData?.id ? [updateData?.name] : [""],
          }}
          // validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
        >
          {(formik) => (
            <FormModal formik={formik} handleCloseModal={handleCloseModal} title={updateData?.id ? "Update RRB" : "Add RRB"}>
              <div className="form-group">
                <label htmlFor="rrbs">RRB:</label>
                <div>
                  {formik?.values?.rrbs?.map((val, index) => {
                    return (
                      <div key={index}>
                        <div className="d-flex align-items-center mb-2">
                          <input
                            type="text"
                            name={`rrbs[${index}]`}
                            value={val}
                            placeholder="Enter RRB"
                            className="form-control mr-2"
                            onChange={(e) =>
                              handleChange(formik, index, e.target.value)
                            }
                            onInput={(e) => {
                              const value = e.target.value;
                              e.target.value = value.slice(0, 25); // Limit to 10 digits
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div className="select-error">{isRRBError}</div>
                </div>
              </div>
            </FormModal>
          )}
        </Formik>
      )}
      <ConfirmModal
        confirmFn={deleteFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default RrbPageUi;
